module.exports = __webpack_public_path__ + "static/media/trophy_leaderboard_crest.0777aa61.svg";